import { selector } from 'recoil';
import { notificationsAtom } from './atoms.js';
import { NotificationPosition } from './models.js';

var notificationPositionnedSelector = selector({
    key: "Component-NotificationSorterSelector",
    get: function (_a) {
        var get = _a.get;
        var notifications = get(notificationsAtom);
        var sorted = [];
        var _loop_1 = function (position) {
            var notificationsByOnePosition = notifications.filter(function (n) { return n.position === NotificationPosition[position]; });
            sorted.push({
                position: NotificationPosition[position],
                notifications: notificationsByOnePosition
            });
        };
        for (var position in NotificationPosition) {
            _loop_1(position);
        }
        return sorted;
    }
});

export { notificationPositionnedSelector };
//# sourceMappingURL=selectors.js.map
